import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  constructor() {
  }

  @Input() breadcrumb: object = { 'links': [] };
  @Input() title: string;
  @Input() hideChangeMode: boolean = false;
  @Input() hideCreateButton: boolean = false;
  @Input() hideImportButton: boolean = true;
  @Input() hideSearchFilter: boolean = true;

  @Input() createUrl: string = 'create';

  @Output() changeModeCard = new EventEmitter<string>();
  @Output() changeModeTable = new EventEmitter<string>();
  @Output() searchFilterChanged = new EventEmitter<string>();

  showChangeMode: boolean = false;

  searchFilter: string = "";

  ngOnInit() {
    this.onResize();
    this.processBreadCrumbLinks();
  }

  clearSearchFilter() {
    this.searchFilter = '';
    this.searchFilterChanged.emit(this.searchFilter);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let screenWidth = window.innerWidth;
    if (screenWidth < 768) {
      this.showChangeMode = false;
      this.changeModeCard.emit();
    } else {
      this.showChangeMode = true;
    }
  }

  private processBreadCrumbLinks() {
  }
}
